import React, { useState, useEffect,useCallback, useMemo } from "react";
import {
  MotifIcon,
  MotifErrorMessage,
  MotifToast,
  MotifFileUploaderItem,
  MotifFileUploader,
  MotifLabel,
  MotifButton,
  MotifSelect,
  MotifFormField,
  MotifOption,
  MotifProgressIndicator,
  MotifProgressIndicatorStep,
  MotifInput,
  MotifTooltip,
} from "@ey-xd/motif-react";
import { useNavigate } from "react-router-dom";
import JSZip from "jszip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import { apiQueryWithToken, apiQueryToUploadDataRegional } from "../../common/services/apiBaseUrlConfig";
import { getAccount } from "../../common/services/commonService";
import { useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { checkIcon, infoIcon } from '../../common/MotifIcons';
import useLogin from "../../common/redux/common/login/useLogin";
import { AMERICAS, APAC, EMEIA, PARTNER, UNITED_KINGDOM, USER } from "../../common/contants/constants";

import "./uploadPartnerEngagementData.scss";
import logger from "../../common/utils/logger";
import { beginLongRunningTask } from "../../common/services/activityMonitor";

export const UploadPartnerEngagementData = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [marketSize, setMarketSize] = useState("");
  const [country, setCountry] = useState("");
  const [sectorId, setSectorId] = useState(0);
  const [subsectorId, setSubsectorId] = useState(0);
  const [subSubsectorId, setSubSubsectorId] = useState(0);
  const [functions, setFunctions] = useState("");
  const [region, setRegion] = useState("");
  const [area, setArea] = useState("");
  const [config, setConfig] = useState("FDD");
  const [detailsStatus, setDetailsStatus] = useState("active");
  const [uploadStatus, setUploadStatus] = useState("disabled");
  const [isEnterDetails, setIsEnterDeatils] = useState(true);
  const [isProceedDisabled, setIsProceedDisabled] = useState(true);
  const [isUploadDisabled, setIsUploadDisabled] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showUploads, setShowUploads] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState([]);
  const [showError, setShowError] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [clientName, setClientName] = useState("");
  const [role, setUserRole] = useState(USER);
  const [engagementId, setEngagementId] = useState("");
  const [engagementIdExist, setEngagementIdExist] = useState("");
  const [isValidEngagementId, setIsValidEngagementId] = useState(true);
  const [sslCompletency, setSslCompetency] = useState("");
  const [percent, setPercent] = useState([]);
  const [removable, setRemovable] = useState(true);
  const [isLargeZipFile, setIsLargeZipFile] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [showZipModal, setShowZipModal] = useState(false);
  const [isExists, setIsExists] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [password, setPassword] = useState("");
  const [baseURL, setBaseURL] = useState("");
  const [showRestrictedDialog, setShowRestrictedDialog] = useState(false); // New state for restricted dialog
  const [showTokenExpiryDialog, setShowTokenExpiryDialog] = useState(false); // New state for restricted dialog


  const location = useLocation();
  const engagementIdList = location.state?.engagementIdList || {};

  const {loginDetail, loading, error}  = useLogin();

  useEffect(() => {
        if (area === AMERICAS) {
      setBaseURL(process.env.REACT_APP_API_URL_US)
    } else if (area === EMEIA) {
      setBaseURL(process.env.REACT_APP_API_URL_EU)
    } else if (area === APAC) {
      setBaseURL(process.env.REACT_APP_API_URL_AU)
    }
  }, [area])

  useEffect(() => {
    setIsLoading(true); // Set loading state to true

    const cachedData = sessionStorage.getItem("userDataCache"); // Check session storage for cached data

    if (cachedData) {
      // If data exists in session storage, use it
      setUserData(JSON.parse(cachedData)); // Parse the JSON string to an object
      setIsLoading(false); // Set loading state to false
    } else {
      // If no cached data, make the API call
      apiQueryWithToken
        .get(`api/Insights/GetApplicationData`)
        .then((data) => {
          setUserData(data.data); // Set user data with the fetched data

          // Store fetched data in session storage for future use
          sessionStorage.setItem(
            "userDataCache", // Key for user data in session storage
            JSON.stringify(data.data) // Convert the data to a JSON string
          );
          setIsLoading(false); // Set loading state to false
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            navigate('/'); // Redirect if unauthorized
          } else {
            logger.error('An error occurred:', error);
            setIsLoading(false); // Set loading state to false even if there is an error
          }
        });
    }
  }, []);

  const getRole = useCallback(() => {
    try {
      const userRole = loginDetail?.userRole || USER;
      if (userRole === "User doesn't exsist" || userRole === "") {
        setShowRestrictedDialog(true); // Show restricted dialog if role is User
      } else {
        setShowRestrictedDialog(false);
      }
      setShowTokenExpiryDialog(false);
      return Promise.resolve(userRole); // Return a resolved Promise with the role data
    } catch (error) {
      logger.error(error);
      //setShowTokenExpiryDialog(true); // Show token expiry dialog in case of an error
      return Promise.resolve(USER); // Return a resolved Promise with the default role
    }
  }, [loginDetail]);
  useEffect(() => {
    // Fetch the role when the component mounts
    getRole().then(fetchedRole => {
      setUserRole(fetchedRole);
    });
  }, [getRole]);

  useEffect(() => {
    if (role === PARTNER) {
      if (
        region && country && projectName && clientName && engagementId && marketSize && sector && subSector && subSubsector && sslCompletency && !engagementIdExist && isValidEngagementId && area
      ) {
        setDetailsStatus("completed");
        setIsProceedDisabled(false);
      } else {
        setDetailsStatus("active");
        setIsProceedDisabled(true);
      }
    }
  }, [marketSize, country, sslCompletency, sectorId, subsectorId, subSubsectorId, functions, engagementId, region, projectName, clientName, area]);

  const handlePrimaryClick = () => {
    if (isEnterDetails) {
      setIsEnterDeatils(false);
      setUploadStatus("active");
      setIsUploadDisabled(true);
    } else {
      setShowModal(true);
    }
  };

  const subSector = useMemo(() => {
    if (subsectorId > 0) {
      return userData?.subSectorLists?.find((item) => {
        return item.subsectorID === subsectorId
      })?.subSectorName
    } else {
      return "";
    }
  }, [subsectorId])

  const sector = useMemo(() => {
    if (sectorId > 0) {
      return userData?.sectors?.find((item) => {
        return item.sectorId === sectorId
      })?.sectorName
    }
    else {
      return "";
    }
  }, [sectorId])

  const subSubsector = useMemo(() => {
    if (subSubsectorId > 0) {
      return userData?.subSubSectorLists?.find((item) => {
        return item.subSubSectorID === subSubsectorId
      })?.subSubSectorName
    }
    else {
      return "";
    }
  }, [subSubsectorId])

  const onProjectNameClick = (event) => {
    const trimmedValue = event.target.value.trimStart().replace(/\s+/g, ' ');
    const cleanedValue = trimmedValue.replace(/[^a-zA-Z0-9 ]/g, '');
    setProjectName(cleanedValue);
  }
  const onClientNameClick = (event) => {
    const trimmedValue = event.target.value.trimStart().replace(/\s+/g, ' ');
    const cleanedValue = trimmedValue.replace(/[^a-zA-Z0-9-&. ]/g, '');
    setClientName(cleanedValue);
  };
  const onEngagementIdClick = (event) => {
    const trimmedValue = event.target.value.trimStart().replace(/\s+/g, ' ');
    const cleanedValue = trimmedValue.replace(/[^0-9]/g, '');

    // Check if the cleanedValue is of length 8 and does not start with 0
    const isValidEngagementId = cleanedValue.length === 8 && !cleanedValue.startsWith('0');
    checkEngagementIdRecordExist(cleanedValue);
    setEngagementId(cleanedValue);
    if (isValidEngagementId) {
      setIsValidEngagementId(true);
    } else {  // Set invalidEngagementId as true if the ID is not valid
      setIsValidEngagementId(false);
    }

  }
  const checkEngagementIdRecordExist = (trimmedValue) => {
    if (trimmedValue) {
      const valuesArray = Object.values(engagementIdList);
      const exists = valuesArray.some(value => value.toLowerCase() === trimmedValue.toLowerCase());
      setEngagementIdExist(exists);
      logger.info("checkexist", exists);
    } else {
      setEngagementIdExist(false);
    }
  };

  const generateGUID = () => {
    const guid = uuidv4();
    return guid;
  };


  const onAlertModalClose = () => {
    setShowAlertModal(false);
  };

  const onZipModalClose = (event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setShowZipModal(false);
      setShowModal(true);
    }
  };

  // Wrappers around the two upload paths so the inactivity timeout is held open
  // for the whole transfer. `isUploadDisabled` and `isLoading` are not usable as
  // the signal here: both are also toggled for validation, and the `isLoading`
  // calls that would have bracketed the chunk loop are commented out.
  const uploadFilesInBatches = async (files) => {
    const endLongRunningTask = beginLongRunningTask("engagement-batch-upload");
    try {
      return await runUploadFilesInBatches(files);
    } finally {
      endLongRunningTask();
    }
  };

  const runUploadFilesInBatches = async (files) => {
    // setIsLoading(true);
    setIsUploadDisabled(true);
    const transactionID = generateGUID(); // Generate a single transaction ID for all chunks
    const data = []
    files.map((file) => {
      const formData = new FormData();
      formData.append("ModifiedBy", "Test");
      formData.append("SubSector", subSector);
      formData.append("SubSubSector", subSubsector);
      formData.append("EngagementId", engagementId);
      formData.append("UserID", 12);
      formData.append("Sector", sector);
      formData.append("UserEmailID", getAccount()?.username);
      formData.append("Country", country);
      formData.append("projectName", projectName);
      formData.append("clientName", clientName);
      formData.append("sectorId", sectorId);
      formData.append("subSectorId", subsectorId);
      formData.append("subSubSectorId", subSubsectorId);
      formData.append("Function", "Default");
      formData.append("Config_file", "config");
      formData.append("Revenue", marketSize);
      formData.append("SSLCompetancy", sslCompletency);
      formData.append("CreatedBy", getAccount()?.name);
      formData.append("Files", file);
      formData.append('TransactionID', transactionID);
      formData.append("Exsists", isExists);
      formData.append("Region", area);
      formData.append("NewRegion", region);
      formData.append("Area", area);
      formData.append("eng_password", password);
      data.push({ formData, fileName: file.name });   // Store the file name for later reference
    })
    const postRequests = data.map(({ formData, fileName }) => {
      return apiQueryToUploadDataRegional.post(`${baseURL}/api/partners/add`, formData, {
        onUploadProgress: (progressEvent) => {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (percentCompleted === 100) {
            percentCompleted = Math.floor(Math.random() * (10) + 90);
          }
          setPercent(prevPercent => {
            const newPercent = [...prevPercent];
            const fileIndex = newPercent.findIndex(p => p.fileName === fileName);
            if (fileIndex !== -1) {
              newPercent[fileIndex].percentage = percentCompleted;
            } else {
              newPercent.push({
                fileName: fileName,
                percentage: percentCompleted
              });
            }
            return newPercent;
          });
        }
      }).then(response => {
        // Once the API response is received, set the percentage to 100%
        setPercent(prevPercent => {
          const newPercent = [...prevPercent];
          const fileIndex = newPercent.findIndex(p => p.fileName === fileName);
          if (fileIndex !== -1) {
            newPercent[fileIndex].percentage = 100;
          }
          return newPercent;
        });
        return {
          status: "Success",
          fileName: fileName,
          response: response.data
        };
      }).catch(error => {
        // Handle the error case if needed
        return {
          status: "Error",
          fileName: fileName,
          error: error
        };
      });
    });

    const responses = await Promise.all(postRequests);
    // Now 'responses' is an array of objects with status, fileName, and either response or error

    setResult(responses); // Set the result state with the array of responses
    // setIsLoading(false);
    setUploadStatus("completed");
    setShowSuccess(true);
    setIsLoading(false);
    setShowModal(true);
    setIsUploadDisabled(false);
  };


  const uploadZipFileInChunks = async () => {
    const endLongRunningTask = beginLongRunningTask("engagement-zip-chunk-upload");
    try {
      return await runUploadZipFileInChunks();
    } finally {
      endLongRunningTask();
    }
  };

  const runUploadZipFileInChunks = async () => {
    const transactionID = generateGUID(); // Generate a single transaction ID for all chunks
    const chunkSize = 5 * 1024 * 1024; // 5MB
    const totalChunks = Math.ceil(files[0].size / chunkSize);
    let chunkPercentages = new Array(totalChunks).fill(0); // Initialize progress for each chunk
    const fileName = files[0].name;
    const newFileName = fileName.replace(/\.zip$/, '') + '-' + transactionID + '.zip';
    setIsUploadDisabled(true);

    const uploadChunk = async (chunk, index) => {
      let regionX = '';
      if (country === UNITED_KINGDOM) {
        regionX = 'EMEIA'
      } else {
        regionX = area
      }
      const formData = new FormData();
      // Append other form data as needed
      formData.append("Region", regionX);
      formData.append("UserEmailID", getAccount()?.username);
      formData.append('Chunk', chunk);
      formData.append('chunkIndex', index);
      formData.append('totalChunks', totalChunks);
      formData.append('FileName', newFileName);
      formData.append('TransactionID', transactionID);

      return apiQueryToUploadDataRegional.post(`${baseURL}/api/partners/Uploading`, formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          chunkPercentages[index] = percentCompleted;
          const totalPercentCompleted = chunkPercentages.reduce((acc, curr) => acc + curr, 0) / totalChunks;
          let totalPercentCompletedRounded = parseFloat(totalPercentCompleted.toFixed(0)); // Round to two decimal places
          if (totalPercentCompletedRounded === 100) {
            totalPercentCompletedRounded = Math.floor(Math.random() * (10) + 90);
          }
          // Update the overall progress in the percent state
          setPercent(prevPercent => {
            const fileIndex = prevPercent.findIndex(p => p.fileName === fileName);
            if (fileIndex !== -1) {
              const newPercent = [...prevPercent];
              newPercent[fileIndex] = {
                fileName: fileName,
                percentage: totalPercentCompletedRounded
              };
              return newPercent;
            } else {
              return [...prevPercent, { fileName: fileName, percentage: totalPercentCompletedRounded }];
            }
          });
        }
      });
    };

    // Create an array of promises for all chunks except the last one
    const promises = [];
    for (let i = 0; i < totalChunks - 1; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, files[0].size);
      const chunk = files[0].slice(start, end);
      promises.push(uploadChunk(chunk, i));
    }

    // Upload all chunks except the last one
    try {
      await Promise.all(promises);
      // After all chunks except the last one have been uploaded, upload the last chunk
      const lastChunkIndex = totalChunks - 1;
      const start = lastChunkIndex * chunkSize;
      const end = files[0].size;
      const lastChunk = files[0].slice(start, end);
      await uploadChunk(lastChunk, lastChunkIndex);
      // All chunks have been uploaded successfully
      confirmZipUpload(transactionID, newFileName, fileName);

    } catch (error) {
      logger.error(`Error uploading chunks`, error);
      setResult([{ isSuccess: false }]);
      setShowSuccess(true);
      setShowModal(true);
    }
  };

  const onConfirmClick = () => {
    setRemovable(false);
    if (isLargeZipFile) {
      // If it's a large ZIP file, use the chunked upload logic
      uploadZipFileInChunks(files);
    } else {
      // Otherwise, use the normal batch upload logic
      uploadFilesInBatches(files);
    }
    setShowModal(false);
    setPassword("");
  };

  const getSameFiles = (array1, array2, key) => {
    return array1.filter(item1 => array2.some(item2 => item1[key] === item2[key]));
  }

  const removeCommonFiles = (array1, array2, key) => {
    return [
      ...array1.filter(obj1 => !array2.some(obj2 => obj1[key] === obj2[key]))
    ];
  }


  const onDrop = (selectedFiles) => {

    let foundInvalidFile = false;
    const listFilesInZip = (zip, pathPrefix = "") => {
      setIsLoading(true);// Flag to indicate if an invalid file was found

      Object.keys(zip.files).forEach((filename) => {
        if (foundInvalidFile) return;

        const file = zip.files[filename];
        if (!file.dir) {
          const extension = filename.substr(filename.lastIndexOf(".") + 1).toLowerCase();

          if (['pdf', 'csv', 'pptx', 'doc', 'docx', 'xlsx', 'xlsb', 'ppt', 'xlsm', 'zip', 'pbix', 'pbi', 'txt'].includes(extension)) {
            file["error"] = false;
          } else {
            file["error"] = true;
            foundInvalidFile = true;
            return;
          }

          if (!file["error"]) {
            logger.info(pathPrefix + filename);
          }

          if (extension === "zip" && !file["error"]) {
            zip
              .file(filename)
              .async("arraybuffer")
              .then((content) => {
                JSZip.loadAsync(content).then((nestedZip) => {
                  listFilesInZip(nestedZip, pathPrefix + filename + "/");
                });
              });
          }
        }
      });

      setIsLoading(false);

      if (foundInvalidFile) {
        setShowAlertModal(true);
        setAlertMessage("Please try uploading again as one or more file types are not supported.");
        setFiles([]);
      }
    };

    // Process each selected file
    selectedFiles.forEach((file) => {
      if (file.path.endsWith(".zip")) {
        const reader = new FileReader();
        reader.onload = function (event) {
          const data = event.target.result;
          JSZip.loadAsync(data).then((zip) => {
            listFilesInZip(zip); // Start the recursive listing with the top-level zip
          });
        };
        reader.readAsArrayBuffer(file);
      }
    });
    const matchingFiles = getSameFiles(selectedFiles, files, 'name');
    const newFiles = removeCommonFiles(selectedFiles, matchingFiles, 'name');
    const totalSize = files.reduce((acc, file) => acc + file.size, 0) + newFiles.reduce((acc, file) => acc + file.size, 0);

    newFiles.forEach((file) => {
      const extension = file?.path.substr(file?.path.lastIndexOf(".") + 1).toLowerCase();
      if (['pdf', 'csv', 'pptx', 'doc', 'docx', 'xlsx', 'xlsb', 'ppt', 'xlsm', 'zip', 'txt'].includes(extension)) {
        file["error"] = false;
      } else {
        file["error"] = true;
      }
      // Check if the file is a ZIP and larger than 2 GB
      if (file.path.endsWith('.zip') && file.size > 50 * 1024 * 1024 * 1024) { // 2 GB in bytes
        file["error"] = true;
        file["errorMessage"] = "Uploads exceeding 50GB cannot be processed. Please divide your upload into smaller segments before uploading.";
      }
    });

    const invalidFiles = newFiles.some(file => file.error === true);
    if (invalidFiles) {
      // Find the first file with an error message and use it for the alert
      const firstInvalidFile = newFiles.find(file => file.error === true);
      const errorMessage = firstInvalidFile.errorMessage || `Please try uploading again as one or more file types are not supported.`;
      setShowAlertModal(true);
      setAlertMessage(errorMessage);
    } else {
      // Check if there is a mix of ZIP and non-ZIP files among the new files
      const zipFiles = newFiles.filter(file => file.path.endsWith('.zip'));
      const nonZipFiles = newFiles.filter(file => !file.path.endsWith('.zip'));

      // Check if there is a mix of ZIP and non-ZIP files between the new files and existing files
      const existingZipFiles = files.filter(file => file.path.endsWith('.zip'));
      const existingNonZipFiles = files.filter(file => !file.path.endsWith('.zip'));

      if ((zipFiles.length > 0 && nonZipFiles.length > 0) ||
        (zipFiles.length > 0 && existingNonZipFiles.length > 0) ||
        (nonZipFiles.length > 0 && existingZipFiles.length > 0)) {
        // Alert the user that they cannot upload ZIP and non-ZIP files together
        setShowAlertModal(true);
        setAlertMessage("Upload ZIP and non-ZIP files separately, simultaneous uploads of both types are not allowed.");
      } else if (zipFiles.length > 1 || (zipFiles.length > 0 && existingZipFiles.length > 0)) {
        // Alert the user that they cannot upload more than one ZIP file at a time
        setShowAlertModal(true);
        setAlertMessage("Please try uploading a single ZIP file at a time.");
      } else if (totalSize <= 750 * 1024 * 1024 && zipFiles.length === 0 && (existingNonZipFiles.length + nonZipFiles.length) <= 75) { // 500 MB in bytes
        setFiles([...files, ...newFiles]);
        setShowUploads(true);
        setIsUploadDisabled(false);
        setIsLargeZipFile(false);
        setShowAlertModal(true);
        setAlertMessage('Files are ready for upload. Click "Upload" to proceed.');

      } else if (zipFiles.length === 1 && existingZipFiles.length === 0 && existingNonZipFiles.length === 0) {
        // The file is a ZIP and it's the only file, proceed with the upload
        setFiles([...files, ...newFiles]);
        setShowUploads(true);
        setIsUploadDisabled(false);
        setIsLargeZipFile(true);
        setShowAlertModal(true);
        setAlertMessage('Files are ready for upload. Click "Upload" to proceed.');

      } else {
        // The total size exceeds the limit and it's not a single ZIP file
        setShowAlertModal(true);
        setAlertMessage("Maximum file size exceeded. Upload up to 750MB or use a ZIP for larger files.");
      }
    }

  };

  const onModalClose = (event, reason) => {
    setPassword("");
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setShowModal(false);
    }
    resetFiles();
  };

  const confirmZipUpload = (transactionId, newFileName, fileName) => {

    setIsLoading(true);
    let regionX = '';
    if (country === UNITED_KINGDOM) {
      regionX = 'EMEIA'
    } else {
      regionX = area
    }
    const formData = new FormData();
    formData.append("ModifiedBy", "Test");
    formData.append("SubSector", subSector);
    formData.append("SubSubSector", subSubsector);
    formData.append("EngagementId", engagementId);
    formData.append("UserID", 12);
    formData.append("Sector", sector);
    formData.append("Country", country);
    formData.append("projectName", projectName);
    formData.append("clientName", clientName);
    formData.append("sectorId", sectorId);
    formData.append("subSectorId", subsectorId);
    formData.append("subSubSectorId", subSubsectorId);
    formData.append("Function", "");
    formData.append("Config_file", "config");
    formData.append("Revenue", marketSize);
    formData.append("SSLCompetancy", sslCompletency);
    formData.append("CreatedBy", getAccount()?.name);
    formData.append("FileName", newFileName);
    formData.append("TransactionID", transactionId);
    formData.append("Region", regionX);
    formData.append("NewRegion", region);
    formData.append("Area", area);
    formData.append("UserEmailID", getAccount()?.username);
    formData.append("Exsists", isExists);
    formData.append("eng_password", password);

    apiQueryToUploadDataRegional
      .post(
        `${baseURL}/api/partners/ConfirmZipUpload`,
        formData
      )
      .then((response) => {
        setResult([response.data])
        logger.info("File uploaded successfully", response.data);
        setShowModal(true);
        setPercent([{ fileName: fileName, percentage: 100 }]);
        setShowSuccess(true);
        setIsLoading(false);
        setUploadStatus("completed");

        setIsUploadDisabled(false);

      })
      .catch((error) => {


        if (error.response && error.response.status === 500) {
          if (error.response.data.statusCode && error.response.data.statusCode === 406) {
            setShowZipModal(true);
            // setShowModal(true);
            setIsLoading(false);
            setAlertMessage("The password provided is invalid for the ZIP file. Please try uploading it again with the correct password.");
          }
        } else {
          setShowModal(true);
          logger.error("Error uploading file", error);
          setResult([{ isSuccess: false }])
          setShowSuccess(true);
          setIsLoading(false);
          //  setShowModal(true);
          setUploadStatus("failed");
          setIsUploadDisabled(false);
        }
      });

  }

  const resetFiles = () => {
    setShowModal(false);
    setFiles([]);
    setIsUploadDisabled(true);
    setShowSuccess(false);
    setResult([]);
    setPassword("");
    setPercent([]);
    setIsExists(true);
  }

  const onOKClick = () => {
    setShowModal(false);
    navigate('/uploadedFiles');
    setPassword("");
  }
  const hanldeTertiaryClick = () => {
    navigate('/uploadedFiles');

  }
  const hanldeSecondaryClick = () => {
    if (isEnterDetails) {
      setShowError(true);
      setEngagementIdExist(false);
      setConfig("FDD");
      setCountry("");
      setSectorId(0);
      setSubsectorId(0);
      setSubSubsectorId(0);
      setRegion("");
      setEngagementId("");
      setFunctions("");
      setSslCompetency("");
      setMarketSize("");
      setDetailsStatus("active");
      setProjectName("");
      setClientName("");
      setArea("");
      setIsProceedDisabled(true);
    } else {
      setIsEnterDeatils(true);
      setFiles([]);
    }
  };

  return (
    <section>
      <div className="uploadPartnerData-container">
        <div className="head-wrapper">
          <MotifLabel className="heading">{role === PARTNER && isEnterDetails ? 'Add Engagement' : 'Upload Data'}</MotifLabel>
          <div className="button-wrapper">
            <MotifButton
              onClick={hanldeTertiaryClick}
              size="small"
              variant="primary"
            >
              {"View All Engagements"}
            </MotifButton>
            <MotifButton
              onClick={hanldeSecondaryClick}
              size="small"
              variant="secondary"
            >
              {isEnterDetails ? "Clear" : "Back"}
            </MotifButton>
            <MotifButton
              onClick={handlePrimaryClick}
              size="small"
              disabled={isEnterDetails ? isProceedDisabled : isUploadDisabled}
              variant="primary"
            >
              {isEnterDetails ? "Proceed" : "Upload"}
            </MotifButton>
          </div>
        </div>
        <div className="wrapper">
          <div className="progress">
            <MotifProgressIndicator variant="row">
              <MotifProgressIndicatorStep
                heading="Enter Details"
                status={detailsStatus}
              />
              <MotifProgressIndicatorStep
                heading="Upload Data"
                status={uploadStatus}
                className="second"
              />
            </MotifProgressIndicator>
          </div>
          {isEnterDetails ? (
            !isLoading ? (
              <div className="first-step">
                <MotifLabel className="form-heading">
                  {role === PARTNER ? 'Please complete the Engagement Profile below to process the Engagement data:' : 'Enter Details to Proceed'}
                </MotifLabel>
                {
                  <>
                    <div className="container">
                      <div className="field">
                        <>
                          <MotifLabel
                            aria-label="engagementId"
                            htmlFor="engagementId"
                          >
                            Engagement Id
                          </MotifLabel>
                          <img src={require("../../../src/common/images/asterisk.png")} alt="" />
                          <MotifFormField
                            aria-label="engagementId"
                            role="group"
                          >
                            <MotifInput
                              aria-label="engagementId"
                              id="engagementId"
                              label="engagementId"
                              type="text"
                              maxLength="8"
                              onChange={onEngagementIdClick}

                              value={engagementId}
                            />
                          </MotifFormField>
                          {!engagementId && showError && (
                            <MotifErrorMessage id="select-error-reactive">
                              Engagement Id is Required
                            </MotifErrorMessage>
                          )}
                          {!isValidEngagementId && !engagementIdExist && (
                            <MotifErrorMessage id="select-error-reactive">
                              Enter valid 8 digit Engagement Id
                            </MotifErrorMessage>
                          )}
                          {role === PARTNER && engagementIdExist && (
                            <MotifErrorMessage id="select-error-reactive">
                              Engagement Id already exists
                            </MotifErrorMessage>
                          )}
                        </>
                      </div>
                      <div className="field">
                        <>
                          <MotifLabel
                            aria-label="projectName"
                            htmlFor="projectName"
                          >
                            Project Name
                          </MotifLabel>
                          <img src={require("../../../src/common/images/asterisk.png")} alt="" />
                          <MotifFormField
                            aria-label="projectName"
                            role="group"
                          >
                            <MotifInput
                              aria-label="projectName"
                              id="projectName"
                              label="projectName"
                              type="text"
                              maxLength="100"
                              onChange={onProjectNameClick}

                              value={projectName}
                            />
                          </MotifFormField>
                          {!projectName && showError && (
                            <MotifErrorMessage id="select-error-reactive">
                              Project Name is Required
                            </MotifErrorMessage>
                          )}
                        </>
                      </div>
                      <div className="field">
                        <>
                          <MotifLabel
                            aria-label="clientName"
                            htmlFor="clientName"
                          >
                            Client Name
                          </MotifLabel>
                          <img src={require("../../../src/common/images/asterisk.png")} alt="" />
                          <MotifFormField
                            aria-label="clientName"
                            role="group"
                          >
                            <MotifInput
                              aria-label="clientName"
                              id="clientName"
                              label="clientName"
                              type="text"
                              maxLength="100"
                              onChange={onClientNameClick}

                              value={clientName}
                            />
                          </MotifFormField>
                          {!clientName && showError && (
                            <MotifErrorMessage id="select-error-reactive">
                              Client Name is Required
                            </MotifErrorMessage>
                          )}
                        </>
                      </div>
                      <div className="field">
                        <MotifLabel>Area</MotifLabel>
                        <img src={require("../../../src/common/images/asterisk.png")} alt="" />
                        {userData?.areas?.length > 0 && (
                          <MotifFormField key={"area"}>
                            <MotifSelect
                              key={area}
                              ariaLabelledBy="select-label"
                              onChange={(value) => { setArea(value); setRegion(""); setCountry(""); }}
                              placeholder="Select"
                              value={area ? area : ""}
                              triggerButtonProps={{
                                "aria-describedby": "select-error-reactive",
                              }}
                            >
                              {userData?.areas?.map((item) => {
                                return (
                                  <MotifOption
                                    key={item.areaName}
                                    value={item.areaName}
                                  >
                                    {item.areaName}
                                  </MotifOption>
                                );
                              })}
                            </MotifSelect>
                          </MotifFormField>
                        )}
                        {!area && showError && (
                          <MotifErrorMessage id="select-error-reactive">
                            Please select an option from the dropdown!
                          </MotifErrorMessage>
                        )}
                      </div>

                      <div className="field">
                        <MotifLabel>Region </MotifLabel>
                        <img
                          src={require("../../../src/common/images/asterisk.png")}
                          alt=""
                        />
                        <MotifFormField key={"region"}>
                          {userData?.regions?.length > 0 && (
                            <MotifSelect
                              key={region}
                              ariaLabelledBy="select-label"
                              onChange={(value) => {
                                setRegion(value);
                                setCountry("");
                              }}
                              placeholder="Select"
                              value={region ? region : ""}
                              triggerButtonProps={{
                                "aria-describedby": "select-error-reactive",
                              }}
                            >
                              {
                                (() => {
                                  const uniqueRegions = new Set(); // Create a set to track unique region names
                                  userData?.areaRegionCountryMappings
                                    ?.filter((areas) => areas.areaName === area)
                                    .forEach((item) => uniqueRegions.add(item.regionName)); // Add region names to the set

                                  return Array.from(uniqueRegions).sort().map((regionName) => ( // Convert the set to an array and map over it
                                    <MotifOption
                                      key={regionName}
                                      value={regionName}
                                    >
                                      {regionName}
                                    </MotifOption>
                                  ));
                                })()
                              }
                            </MotifSelect>
                          )}
                        </MotifFormField>
                        {!region && showError && (
                          <MotifErrorMessage id="select-error-reactive">
                            Please select an option from the dropdown!
                          </MotifErrorMessage>
                        )}
                      </div>
                      <div className="field">
                        <MotifLabel>Country </MotifLabel>
                        <img
                          src={require("../../../src/common/images/asterisk.png")}
                          alt=""
                        />
                        <MotifFormField key={"country"}>
                          {userData?.countries?.length > 0 && (
                            <MotifSelect
                              key={country}
                              ariaLabelledBy="select-label"
                              onChange={(value) => setCountry(value)}
                              placeholder="Select"
                              value={country ? country : ""}
                              triggerButtonProps={{
                                "aria-describedby": "select-error-reactive",
                              }}
                            >
                              {userData?.areaRegionCountryMappings
                                ?.filter((country) => country.regionName === region)
                                .sort((a, b) => a.countryName.localeCompare(b.countryName)) // Sort the filtered array alphabetically by countryName
                                .map((item) => (
                                  <MotifOption
                                    key={item.countryName}
                                    value={item.countryName}
                                  >
                                    {item.countryName}
                                  </MotifOption>
                                ))}
                            </MotifSelect>
                          )}
                        </MotifFormField>
                        {!country && showError && (
                          <MotifErrorMessage id="select-error-reactive">
                            Please select an option from the dropdown!
                          </MotifErrorMessage>
                        )}
                      </div>
                      <div className="field">
                        <MotifLabel>Sector</MotifLabel>
                        <img src={require("../../../src/common/images/asterisk.png")} alt="" />
                        {role !== PARTNER}
                        <MotifFormField key={"sector"}>
                          {userData?.sectors?.length > 0 && (
                            <MotifSelect

                              key={sectorId}
                              ariaLabelledBy="select-label"
                              onChange={(value) => {
                                setSectorId(value);
                                setSubsectorId(0);
                                setSubSubsectorId(0);
                              }}
                              placeholder="Select"
                              value={sectorId ? sectorId : 0}
                              triggerButtonProps={{
                                "aria-describedby": "select-error-reactive",
                              }}
                            >

                              {userData?.sectors?.map((item) => {
                                return (
                                  <MotifOption key={item.sectorId} value={item.sectorId}>
                                    {item.sectorName}
                                  </MotifOption>
                                );
                              })}
                            </MotifSelect>
                          )}
                        </MotifFormField>
                        {!sectorId && showError && (
                          <MotifErrorMessage id="select-error-reactive">
                            Please select an option from the dropdown!
                          </MotifErrorMessage>
                        )}
                      </div>
                      <div className="field">
                        <MotifLabel>Sub-Sector</MotifLabel>
                        <img src={require("../../../src/common/images/asterisk.png")} alt="" />
                        {role !== PARTNER}
                        <MotifFormField key={"subsector"}>
                          {userData?.subSectorLists?.length > 0 && (
                            <MotifSelect
                              key={subsectorId}

                              ariaLabelledBy="select-label"
                              onChange={(value) => {
                                setSubsectorId(value)
                                setSubSubsectorId(0);
                              }
                              }
                              placeholder="Select"
                              value={subsectorId ? subsectorId : 0}
                              triggerButtonProps={{
                                "aria-describedby": "select-error-reactive",
                              }}
                            >
                              {userData?.subSectorLists
                                ?.filter((subSector) => {
                                  return subSector.sectorId === sectorId;
                                })
                                .map((item) => {
                                  return (
                                    <MotifOption key={item.subsectorID} value={item.subsectorID}>
                                      {item.subSectorName}
                                    </MotifOption>
                                  );
                                })}
                            </MotifSelect>
                          )}
                        </MotifFormField>
                        {!subsectorId && showError && (
                          <MotifErrorMessage id="select-error-reactive">
                            Please select an option from the dropdown!
                          </MotifErrorMessage>
                        )}
                      </div>
                      <div className="field">
                        <MotifLabel>Sub-Sub Sector</MotifLabel>
                        <img src={require("../../../src/common/images/asterisk.png")} alt="" />
                        {role !== PARTNER}
                        <MotifFormField key={"subsubsector"}>
                          {userData?.subSubSectorLists?.length > 0 && (
                            <MotifSelect
                              key={subSubsectorId}

                              ariaLabelledBy="select-label"
                              onChange={(value) => {
                                setSubSubsectorId(value)

                              }
                              }
                              placeholder="Select"
                              value={subSubsectorId ? subSubsectorId : 0}
                              triggerButtonProps={{
                                "aria-describedby": "select-error-reactive",
                              }}
                            >
                              {userData?.subSubSectorLists
                                ?.filter((subsubSector) => {
                                  return subsubSector.subsectorID === subsectorId;
                                })
                                .map((item) => {
                                  return (
                                    <MotifOption key={item.subSubSectorID} value={item.subSubSectorID}>
                                      {item.subSubSectorName}
                                    </MotifOption>
                                  );
                                })}
                            </MotifSelect>
                          )}
                        </MotifFormField>
                        {!subSubsectorId && showError && (
                          <MotifErrorMessage id="select-error-reactive">
                            Please select an option from the dropdown!
                          </MotifErrorMessage>
                        )}
                      </div>
                      <div className="field">
                        <MotifLabel>SSL/Competency</MotifLabel>
                        <img src={require("../../../src/common/images/asterisk.png")} alt="" />
                        {role !== PARTNER}
                        <MotifFormField key={"sslCompletency"}>
                          <MotifSelect
                            key={"sslCompetencySelect"}
                            ariaLabelledBy="select-label-ssl"
                            onChange={(value) => setSslCompetency(value)}
                            placeholder="Select"
                            value={sslCompletency ? sslCompletency : ""}
                            visibleOptions={10}
                            triggerButtonProps={{
                              "aria-describedby": "select-error-reactive-ssl",
                            }}
                          >
                            {/* Hardcoded options */}
                            <MotifOption
                              key="EYP-Strategy"
                              value="EYP-Strategy"
                            >
                              EYP - Strategy
                            </MotifOption>
                            <MotifOption key="EYP-TSE" value="EYP-TSE">
                              EYP - TSE
                            </MotifOption>
                            <MotifOption key="EYP-TRS" value="EYP-TRS">
                              EYP - TRS
                            </MotifOption>
                            <MotifOption key="TCF-LA" value="TCF-LA">
                              TCF - LA
                            </MotifOption>
                            <MotifOption key="TCF-TD" value="TCF-TD">
                              TCF - TD
                            </MotifOption>
                            <MotifOption key="TCF-VME" value="TCF-VME">
                              TCF - VME
                            </MotifOption>
                          </MotifSelect>
                        </MotifFormField>
                        {!sslCompletency && showError && (
                          <MotifErrorMessage id="select-error-reactive-ssl">
                            Please select an option from the dropdown!
                          </MotifErrorMessage>
                        )}
                      </div>
                      <div className="field">
                        <MotifLabel>Revenue Range

                        </MotifLabel>
                        <MotifTooltip
                          allowClick
                          allowHover
                          closeButtonProps={{}}

                          flip


                          id="tooltip"

                          placement="auto"

                          trigger={<MotifIcon src={infoIcon} />}

                          variant="default"
                        >
                          Reported revenue range in USD of the target/business for the most recent fiscal year
                        </MotifTooltip>
                        <img src={require("../../../src/common/images/asterisk.png")} alt="" />

                        {role !== PARTNER}
                        <MotifFormField key={"marketSize"}>
                          {userData?.revenueRanges?.length > 0 && (
                            <MotifSelect
                              key={marketSize}

                              ariaLabelledBy="select-label"
                              onChange={(value) => setMarketSize(value)}
                              placeholder="Select"
                              value={marketSize ? marketSize : ""}
                              triggerButtonProps={{
                                "aria-describedby": "select-error-reactive",
                              }}
                            >
                              {userData?.revenueRanges?.map((item) => {
                                return (
                                  <MotifOption key={item.revenueRanges} value={item.range}>
                                    {item.range}
                                  </MotifOption>
                                );
                              })}
                            </MotifSelect>
                          )}
                        </MotifFormField>
                        {!marketSize && showError && (
                          <MotifErrorMessage id="select-error-reactive">
                            Please select an option from the dropdown!
                          </MotifErrorMessage>
                        )}
                      </div>
                    </div>
                  </>
                }
              </div>
            ) : (
              <MotifProgressLoader show variant="default" />
            )
          ) : (
            <div className="second-step">
              <MotifLabel className="form-heading">
                Choose files to upload
              </MotifLabel>
              <div className="file-upload">
                <MotifFormField>
                  <MotifFileUploader
                    id="my-id"
                    label={"Click to upload or drag and drop"}
                    onDrop={onDrop}
                    reactive
                    disabled={percent.length > 0}
                  ></MotifFileUploader>

                </MotifFormField>
              </div>
              <div className="info-msg-wrapper">
                <div className="info-msg">• You can upload 75 files up to 750MB or one ZIP file up to 2GB.</div>
                <div className="info-msg">• Allowed file types: PDF, DOC, DOCX, XLSX, XLSB, XLSM, CSV, PPTX, PPT.</div>
                <div className="info-msg">• Allowed file types within ZIP : PDF, DOC, DOCX, XLSX, XLSB, XLSM, CSV, PPTX, PPT, TXT, PBIX.</div>
                <div className="info-msg">• The platform does not support direct folder uploads. Please compress the folder into a ZIP file prior to uploading.</div>

              </div>
              {showUploads &&
                files.map((file, index) => {
                  const fileProgress = percent.find(p => p?.fileName === file?.name) || { percentage: 0 };
                  return (
                    <MotifFileUploaderItem
                      key={file.path + index}
                      aria-label="Item aria-label text"
                      fileName={
                        <div className="fileNameContainer">{file.path}</div>
                      }
                      fileSize={file.size}
                      removable={removable}
                      // removable
                      error={file.error}
                      percentUploaded={fileProgress.percentage}
                      showProgress={true}
                      icons={<MotifIcon src={checkIcon} />}
                      fileIcon={fileProgress.percentage == 100 ? <MotifIcon src={checkIcon} /> :
                        <MotifIcon src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTQgMkg2Yy0xLjEgMC0xLjk5LjktMS45OSAyTDQgMjBjMCAxLjEuODkgMiAxLjk5IDJIMThjMS4xIDAgMi0uOSAyLTJWOGwtNi02em0yIDE2SDh2LTJoOHYyem0wLTRIOHYtMmg4djJ6bS0zLTVWMy41TDE4LjUgOUgxM3oiLz48L3N2Zz4=" />
                      }
                      onRemove={() => {
                        const newFiles = files.filter(item => item.path !== file.path);
                        setFiles(newFiles);
                        if ((newFiles.length === 0)) {
                          setIsUploadDisabled(true)
                        }
                      }}
                    />
                  );
                })
              }
              <Dialog
                onClose={onModalClose}
                open={showModal}
                className="custom-dialog"
                disableEscapeKeyDown
              >
                <DialogTitle>{showSuccess ? 'Add more files or Click OK to proceed' : 'Confirm'}</DialogTitle>
                {
                  !showSuccess && (
                    <IconButton
                      onClick={onModalClose}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  )
                }

                <DialogContent dividers className="modal-content">
                  {showSuccess && isLargeZipFile ? (
                    result?.map((x, index) => {
                      return x.isSuccess ? (
                        <MotifToast key={index} variant="success"> {/* Add a unique key */}
                          <div className="result">
                            {`Zip file uploaded successfully`}
                          </div>
                        </MotifToast>
                      ) : (
                        <MotifToast key={index} variant="error"> {/* Add a unique key */}
                          <div className="result">
                            {`Something went wrong. Please try again`}
                          </div>
                        </MotifToast>
                      );
                    })
                  ) : (
                    result?.map((x, index) => { // Assuming 'result' is an array and not nested under 'result.result'
                      return x.status === "Success" ? (
                        <MotifToast key={index} variant="success"> {/* Add a unique key */}
                          <div className="result">
                            {`${x.fileName ? x.fileName : ''} uploaded successfully`}
                          </div>
                        </MotifToast>
                      ) : (
                        <MotifToast key={index} variant="error"> {/* Add a unique key */}
                          <div className="result">
                            {`${x.fileName ? x.fileName : ''} upload failed. Please try again`}
                          </div>
                        </MotifToast>
                      );
                    })
                  )}
                  {
                    isLoading &&
                    <MotifProgressLoader show variant="default" />
                  }
                  {
                    !showSuccess && <>
                      {<span>Please confirm the data upload</span>}
                      <p>
                        Important: Only one password can be used for each upload, if applicable; otherwise, please leave it blank.
                      </p>
                      <p>
                        If your files have different passwords, upload them in batches. </p>
                      <p>
                        Once you click 'Confirm,' your files will be uploaded to the regional DBS storage for processing by DBS. </p>
                      <p>
                        Please note that the password is not being checked on non-ZIP files until processing. </p>

                      <MotifFormField
                        aria-label="Password"
                        role="group"
                      >
                        <MotifLabel
                          aria-label="Password"
                          for="input"
                        >
                          Enter password
                        </MotifLabel>
                        <MotifInput
                          aria-label="Password"
                          ariaLabel="Password"
                          id="input"
                          label="Password"
                          type="password"
                          onChange={(event) => setPassword(event.target.value)}
                          value={password}

                        />
                        <span className="pwd-msg">Your password is encrypted and stored temporarily and will be deleted after processing the files.</span>

                      </MotifFormField>

                    </>
                  }
                </DialogContent>
                <DialogActions>
                  {
                    showSuccess && (
                      <MotifButton
                        onClick={resetFiles}
                        size="medium"
                        type="button"
                        variant="primary"
                        disabled={isLoading}
                      >

                        Add more files
                      </MotifButton>
                    )
                  }
                  <MotifButton
                    onClick={showSuccess ? onOKClick : resetFiles}
                    size="medium"
                    type="button"
                    variant="secondary"
                    disabled={isLoading}
                  >
                    {
                      showSuccess ? 'OK' : 'Cancel'
                    }
                  </MotifButton>
                  {
                    !showSuccess && <MotifButton
                      onClick={onConfirmClick}
                      size="medium"
                      type="button"
                      disabled={isLoading}
                    >
                      Confirm
                    </MotifButton>
                  }

                </DialogActions>
              </Dialog>
              <Dialog
                onClose={onAlertModalClose}
                open={showAlertModal}
                className="alert-dialog"
              >
                <DialogTitle>
                  <IconButton
                    onClick={onAlertModalClose}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 8,
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <div className="heading">Note</div>
                </DialogTitle>
                <DialogContent dividers className="modal-content">
                  <p>{alertMessage}</p>
                </DialogContent>
                <DialogActions>
                  <MotifButton
                    onClick={onAlertModalClose}
                    color="primary"
                    variant="contained"
                  >
                    OK
                  </MotifButton>
                </DialogActions>
              </Dialog>
              <Dialog
                onClose={onZipModalClose}
                open={showZipModal}
                className="alert-dialog"
              >
                <DialogTitle>
                  <IconButton
                    onClick={() => onZipModalClose(null, 'buttonClick')}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 8,
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <div className="heading">Note</div>
                </DialogTitle>
                <DialogContent dividers className="modal-content">
                  <p>{alertMessage}</p>
                </DialogContent>
                <DialogActions>
                  <MotifButton
                    onClick={onZipModalClose}
                    color="primary"
                    variant="contained"
                  >
                    OK
                  </MotifButton>
                </DialogActions>
              </Dialog>
              <Dialog
                open={showRestrictedDialog}
                onClose={(event, reason) => {
                  if (reason !== 'backdropClick') {
                    setShowRestrictedDialog(false);
                  }
                }}
                className="role-ristrict-dialog"
              >
                <DialogTitle>{"Access Restricted"}</DialogTitle>
                <DialogContent>
                  The role is currently restricted. Please contact the Data Bureau Service at <a href="mailto:DBS@parthenon.ey.com">DBS@parthenon.ey.com</a> for access.
                </DialogContent>
              </Dialog>
              <Dialog
                open={showTokenExpiryDialog}
                onClose={(event, reason) => {
                  if (reason !== 'backdropClick') {
                    setShowTokenExpiryDialog(false);
                  }
                }}
                className="role-ristrict-dialog"
              >
                <DialogTitle>{"Session Timed Out"}</DialogTitle>
                <DialogContent>
                  The session is timed out, please start a new session to log in.
                </DialogContent>
              </Dialog>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
